// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Filter Select Style */
.filter-select {
    width: 220px;
}

/* Keep the › icon inline with button text (overrides NextPage.min.css display:table) */
.button {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
}

/* Uniform width for all action column buttons */
.action-btn-group .button,
.action-btn-group .btn {
    width: 120px;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
}

/* Assessment status chips in the action column */
.assessment-status-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    line-height: 24px;
}

.assessment-status-chip.pending {
    background-color: #fff3e0;
    color: #e65100;
    border: 1px solid #ffcc80;
}

.assessment-status-chip.running {
    background-color: #e3f2fd;
    color: #1565c0;
    border: 1px solid #90caf9;
}

.assessment-status-chip.failed {
    background-color: #fbe9e7;
    color: #c62828;
    border: 1px solid #ef9a9a;
    cursor: help;
}

.assessment-status-chip .status-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
}

.assessment-status-chip .status-icon.spin {
    animation: spin 1.5s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* Ensure data grid takes full width */
.data-grid-wrapper {
    width: 100%;
    overflow-x: auto;
}

/* Ensure container allows full page width */
.container {
    max-width: 100% !important;
    padding: 0 15px;
}

#column {
    width: 100%;
}

.row {
    margin: 0;
}

.btn-back:before {
  content: '‹' !important;
  display: inline-block;
  font-size: 16px;
  padding: 0 5px 0 0;
}

.btn-back:after {
  content: none !important;
}

.rejected-note {
  color: #0057b8;
  font-size: 0.78rem;
  font-style: italic;
  text-align: left;
  margin: 0 0 0.5rem 0;
}

.cmdb-validation-needed-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 12px;
    background: #fff4e5;
    border: 1px solid #ffc36a;
    color: #8a5100;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/applications/applications.component.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,YAAY;AAChB;;AAEA,uFAAuF;AACvF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,gDAAgD;AAChD;;IAEI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,iDAAiD;AACjD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;AACpC;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,4CAA4C;AAC5C;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":["/* Filter Select Style */\n.filter-select {\n    width: 220px;\n}\n\n/* Keep the › icon inline with button text (overrides NextPage.min.css display:table) */\n.button {\n    display: inline-flex;\n    align-items: center;\n    white-space: nowrap;\n}\n\n/* Uniform width for all action column buttons */\n.action-btn-group .button,\n.action-btn-group .btn {\n    width: 120px;\n    justify-content: center;\n    text-align: center;\n    white-space: nowrap;\n}\n\n/* Assessment status chips in the action column */\n.assessment-status-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 10px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n    line-height: 24px;\n}\n\n.assessment-status-chip.pending {\n    background-color: #fff3e0;\n    color: #e65100;\n    border: 1px solid #ffcc80;\n}\n\n.assessment-status-chip.running {\n    background-color: #e3f2fd;\n    color: #1565c0;\n    border: 1px solid #90caf9;\n}\n\n.assessment-status-chip.failed {\n    background-color: #fbe9e7;\n    color: #c62828;\n    border: 1px solid #ef9a9a;\n    cursor: help;\n}\n\n.assessment-status-chip .status-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n}\n\n.assessment-status-chip .status-icon.spin {\n    animation: spin 1.5s linear infinite;\n}\n\n@keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n}\n\n/* Ensure data grid takes full width */\n.data-grid-wrapper {\n    width: 100%;\n    overflow-x: auto;\n}\n\n/* Ensure container allows full page width */\n.container {\n    max-width: 100% !important;\n    padding: 0 15px;\n}\n\n#column {\n    width: 100%;\n}\n\n.row {\n    margin: 0;\n}\n\n.btn-back:before {\n  content: '‹' !important;\n  display: inline-block;\n  font-size: 16px;\n  padding: 0 5px 0 0;\n}\n\n.btn-back:after {\n  content: none !important;\n}\n\n.rejected-note {\n  color: #0057b8;\n  font-size: 0.78rem;\n  font-style: italic;\n  text-align: left;\n  margin: 0 0 0.5rem 0;\n}\n\n.cmdb-validation-needed-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 10px;\n    border-radius: 12px;\n    background: #fff4e5;\n    border: 1px solid #ffc36a;\n    color: #8a5100;\n    font-size: 11px;\n    font-weight: 700;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
